import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import CLabel from '../../../../../Common/CLabel';
import { mergeStyleSets, TooltipHost } from '@fluentui/react';
import { TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { css } from '@fluentui/react/lib/Utilities';
import { useTranslation } from "react-i18next";

function MessageDistributionGroupStatus(props) {
    const { t } = useTranslation();
    
    const objMessage = props.objMessage;

    const classNames = mergeStyleSets({
        overflow: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: 180,
        },
        parent: {
            selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });

    //Render de componente.
    return (
            <Row className='ps-3 pe-3'  style={{borderTop: "1px solid #999"}} >
                <Col xl={12}>
                    <CLabel labelText={ t('data-lang-lbl-visaby') } />
                </Col>
                {
                    objMessage.l_users_visa_to && objMessage.l_users_visa_to.filter(x => x.principal === true).map((user, index) => (
                        <Col key={index} xl={12} className='p-1'>
                            <Card identifier={user.username}>
                                <Card.Body className='p-1'>
                                    <Row>
                                        <Col>
                                            <div>
                                                <TooltipHost
                                                    overflowMode={TooltipOverflowMode.Self}
                                                    // The TooltipHost itself will overflow
                                                    hostClassName={css(classNames.overflow)}
                                                    content={user.fullname}
                                                    onTooltipToggle={false}
                                                    styles={{
                                                        root: { display: 'block' },
                                                    }}
                                                    // In this mode, aria-describedby is automatically added/removed based on tooltip visibility
                                                    >
                                                    <div style={{ fontSize: "12px" }}><b>{ t('data-lang-lbl-name') }</b>: {user.fullname}</div>
                                                </TooltipHost>
                                            </div>
                                            <Row style={{ fontSize: "12px"}}>
                                                <Col>
                                                    {
                                                        user.answeredStatusName === "data-lang-sbsectionpartymessage-answered0" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--MailAlert` } ></i> : <></>
                                                    }
                                                    {
                                                        user.answeredStatusName === "data-lang-sbsectionpartymessage-answered1" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--Mail` } ></i> : <></>
                                                    }
                                                    {
                                                        user.answeredStatusName === "data-lang-sbsectionpartymessage-answered2" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--SendMirrored` } ></i> : <></> 
                                                    }
                                                    {
                                                        user.answeredStatusName === "data-lang-sbsectionpartymessage-answered3" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--ReminderTime` } ></i> : <></>
                                                    }
                                                    {
                                                        user.answeredStatusName === "data-lang-sbsectionpartymessage-answered4" ?
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--EventDateMissed12` } ></i> : <></>
                                                    }
                                                    &nbsp;{t(user.answeredStatusName)}
                                                </Col>
                                                <Col>
                                                {
                                                    user.readStatusName === "data-lang-sbsectionpartymessage-read0" ?
                                                    <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--RadioBtnOff` } ></i> : <></>
                                                }
                                                {
                                                    user.readStatusName === "data-lang-sbsectionpartymessage-read1" ?
                                                    <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--MailAlert` } ></i> : <></>
                                                }
                                                {
                                                    user.readStatusName === "data-lang-sbsectionpartymessage-read2" ?
                                                    <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--Read` } ></i> : <></>
                                                }
                                                &nbsp;{t(user.readStatusName)}
                                                </Col>
                                                {
                                                    objMessage && user.principal === true && objMessage.visa !== 1 && objMessage.visa !== 2 && objMessage.visa !== 3 &&
                                                    <div>
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } }  className={`ms-Icon ms-Icon--AlarmClock`} ></i>
                                                        &nbsp;{t('data-lang-lbl-visapending')}
                                                    </div>
                                                }
                                                {
                                                    objMessage && user.principal === true && objMessage.visa === 2 &&
                                                    <div>
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={`ms-Icon ms-Icon--StatusErrorFull`} ></i>
                                                        &nbsp;{t('data-lang-lbl-visarejected')}
                                                    </div>                                                }
                                                {
                                                    objMessage && user.principal === true && objMessage.visa === 1 &&
                                                                                                        <div>
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={`ms-Icon ms-Icon--SkypeCircleCheck`} ></i>
                                                        &nbsp;{t('data-lang-lbl-visaaproved')}
                                                    </div>
                                                }
                                                {
                                                    objMessage && user.principal === true && objMessage.visa === 3 &&
                                                    <div>
                                                        <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={`ms-Icon ms-Icon--AlertSolid`} ></i>
                                                        &nbsp;{(user.resultVisa === true ? t('data-lang-lbl-visaaprovedbreak') : t('data-lang-lbl-visarejectedbreak'))}
                                                    </div>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))
                }
            </Row>
    );
}

export default MessageDistributionGroupStatus;